var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmoweltScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3f1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1634,
    stopColor: "#ece4a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac8f00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.35498,44.49719c-.57904,0-1.02808.44824-1.02808,1.01447,0,.5426.44904.97906,1.02808.97906.56726,0,1.01636-.44824,1.01636-.97906,0-.26904-.10706-.5271-.29767-.71735s-.44916-.29712-.71869-.29712Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.03638,53.29718v-4.08148c.18915-.43646.67365-.74316,1.15814-.74316.60272,0,1.00452.47186,1.00452,1.15607v3.66858h1.71356v-3.98712c0-1.46277-.94543-2.39465-2.41083-2.39465-.76813,0-1.39441.28314-1.90259.90833-.40186-.60162-1.00452-.90833-1.7608-.90833-.75641,0-1.40631.31848-1.79626.86115v-.69598h-1.60724v6.21661h1.71356v-4.08148c.22455-.43646.68536-.74316,1.1463-.74316.60266,0,1.02814.47186,1.02814,1.15607v3.66858h1.7135Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.49231,
    y: 47.08057,
    width: 1.71356,
    height: 6.21661
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.51294,53.29718v-3.98712c0-1.46277-.94543-2.39465-2.41077-2.39465-.76813,0-1.39453.28314-1.90265.90833-.40179-.60162-1.00446-.90833-1.76086-.90833-.75629,0-1.40625.31848-1.79626.86115v-.69598h-1.60712v6.21661h1.7135v-4.08148c.22455-.43646.68542-.74316,1.1463-.74316.60272,0,1.02814.47186,1.02814,1.15607v3.66858h1.71356v-4.08148c.18909-.43646.67358-.74316,1.15808-.74316.60272,0,1.00452.47186,1.00452,1.15607v3.66858h1.71356Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.56635,53.47412c1.90265,0,3.28528-1.38013,3.28528-3.27936,0-1.91101-1.37079-3.27936-3.28528-3.27936-1.89081,0-3.28522,1.39197-3.28522,3.27936s1.39441,3.27936,3.28522,3.27936ZM44.56635,48.48431c.95728,0,1.57178.67236,1.57178,1.71045,0,1.01453-.63818,1.71051-1.57178,1.71051s-1.57172-.69598-1.57172-1.71051c0-1.01447.63812-1.71045,1.57172-1.71045Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.41278,48.36658c-.72058,0-1.27228.44244-1.48633,1.14423h2.85724c-.1358-.71381-.65417-1.14423-1.37091-1.14423Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.47754,42.40912h-32.26794c4.79791,0,8.21326,3.16138,8.21326,7.59674,0,4.42365-3.42712,7.58502-8.21326,7.58502h32.26794c4.78601,0,8.19562-3.16138,8.19562-7.58502,0-4.43536-3.39758-7.59674-8.19562-7.59674ZM60.10651,53.29669h-1.72534l-1.45715-3.8894-1.42627,3.8894h-1.72528l-2.04437-6.21667h1.83167l1.15491,3.68878,1.42126-3.68878h1.66626l1.42676,3.67572,1.16113-3.67572h1.73712l-2.02069,6.21667ZM68.43817,50.76123h-4.54309c.19049.76819.78162,1.23859,1.60046,1.23859.6145,0,1.099-.25952,1.40631-.74316l1.1936.95557c-.52002.7785-1.46545,1.26215-2.58813,1.26215-1.90259,0-3.3089-1.40375-3.3089-3.27936,0-1.88745,1.38269-3.26764,3.24988-3.26764,1.81989,0,3.01349,1.27405,3.01349,3.24402,0,.21234,0,.42468-.02362.58984ZM71.23877,53.37994c-1.20538,0-1.93805-.71954-1.93805-1.93457v-6.39355h1.74896v6.14587c0,.4364.18909.6488.57904.6488.16718-.00122.33228-.03735.48456-.1062l.21271,1.42737c-.30731.14154-.68542.21228-1.08722.21228ZM75.56403,53.47424c-1.46539,0-2.38715-.87292-2.38715-2.26489v-2.60699h-1.18176v-1.52167h1.18176v-1.49817h1.74902v1.49817h2.1153v1.52167h-2.1153v2.45367c0,.49542.31903.79028.86267.79028.34271,0,.63812-.0943.93359-.28308l.61462,1.40381c-.52014.34204-1.09924.5072-1.77277.5072Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmoweltScraper);
export default __webpack_public_path__ + "static/media/immowelt-scraper.9dfd8243901088a24e6156d0fbe6f694.svg";
export { ForwardRef as ReactComponent };